{
  "name": "his-api-client",
  "version": "0.8.1",
  "min-api-version": "4.19.2",
  "description": "Api client for accessing openmrs service",
  "main": "./dist/index.js",
  "module": "./dist/index.mjs",
  "types": "./dist/index.d.ts",
  "files": [
    "dist"
  ],
  "scripts": {
    "build": "tsup",
    "test": "echo \"Error: no test specified\" && exit 1"
  },
  "author": "Andrew Mfune",
  "license": "ISC",
  "devDependencies": {
    "ts-node": "^10.9.1",
    "tsup": "^7.2.0",
    "typescript": "^5.2.2"
  },
  "keywords": ["BHT-EMR-API Client", "BHT-EMR-API", "H.I.S", "EMR", "EMR Client", "POC", "POC Client", "Emastercard"]
}
